import MedicalAdapter from './base';

export default class Medication extends MedicalAdapter {
  modelNamePlural = 'medications';
}
